import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ActivityCreator from "../../../../components/ActivityCreator";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";

const ActivityCreate = props => (
  <div className="container">
    <Breadcrumb
      current={props.currentRoute}
      items={[{ path: "/activity/list", to: "/activity/list" }]}
    />
    <ActivityCreator {...props} />
    <ProtectedRoute routeId={props.currentRoute} />
  </div>
);

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreate);
